import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { EWConfigurationService } from 'src/app/service/management/ew-configuration.service';

@Component({
    selector: 'app-exclusion-parameters-dialog',
    templateUrl: './exclusion-parameters-dialog.component.html',
    styleUrls: ['./exclusion-parameters-dialog.component.scss'],
    standalone: false
})
export class ExclusionParametersDialogComponent implements OnInit {
  heading: string;
  eventType: string;
  id: number;
  enableError = false;
  errormsg: string;

  routeList = []
  selectedRouteId;
  selectedRouteValue;
  domicileList = []
  ewconfigurationList = []
  selectedEWConfigurationId;
  selectedDomicile
  domicileRouteMasterList = []

  routedate
  modifiedroutedate
  ewID;
  description;
  alarmID;
  parameters;
  route;

  selectedPeriodId
  constructor(public dialogRef: MatDialogRef<ExclusionParametersDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly ewconfigureService: EWConfigurationService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    this.routeList = []
    this.domicileList = []
    this.domicileRouteMasterList = this.dataStore.domicileRouteMasterList
    this.domicileRouteMasterList.forEach((obj, index) => {
      if (obj.domicile != null)  // NOSONAR
        {this.domicileList.push({ id: index + 1, value: String(obj.domicile).trim() })}
    })
    this.domicileList = [... new Map(this.domicileList.map(x => [x['value'], x])).values()];
    this.domicileList.sort((a, b) => (a.value > b.value ? 1 : -1))
    this.ewconfigurationList = this.dataStore.ewconfigurelist;
    this.selectedPeriodId = this.dataStore.selectedPeriodId;
    if (this.eventType == 'EDIT') {  // NOSONAR

      this.ewID = this.dataStore.ewID
      this.description = this.dataStore.description
      this.alarmID = this.dataStore.alarmID
      this.parameters = this.dataStore.parameters
      this.route = this.dataStore.route
      this.routedate = this.dataStore.routeDate

      const tempSelectEW = this.ewconfigurationList.find(x => x.value == this.description)  // NOSONAR
      if (tempSelectEW) {
        this.selectedEWConfigurationId = tempSelectEW.id
      }
      const tempSelectedRouteDate = this.routedate?.split("-")
      if (tempSelectedRouteDate) {
        this.modifiedroutedate = tempSelectedRouteDate[2] + '-' + tempSelectedRouteDate[0] + '-' + tempSelectedRouteDate[1]
        this.routedate = this.modifiedroutedate
      }
      const tempSelectedDomiciles = this.dataStore.domicile?.split(",")
      if (tempSelectedDomiciles) {
        tempSelectedDomiciles.forEach(element => {
          const tempElementFound = this.domicileList.findIndex(x => x.value == element)  // NOSONAR
          if (tempElementFound > -1) {
            this.domicileList[tempElementFound].isChecked = true;
          }
        });
      }
      this.selectedRouteValue = this.route;
      this.domicileListChange();
      const selectedRoute = this.routeList.find(x => x.value == this.route)  // NOSONAR
      if (selectedRoute) {
        this.selectedRouteId = selectedRoute.id
        this.selectedRouteValue = selectedRoute.value

      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }

  dateChange() {
    this.modifiedroutedate = null;
    if (this.routedate && this.routedate.toString().trim().length) {
      this.modifiedroutedate = this.routedate.split('-');
      this.modifiedroutedate = this.modifiedroutedate[1] + '-' + this.modifiedroutedate[2] + '-' + this.modifiedroutedate[0]
    }
  }
  routeChange() {
    this.selectedRouteValue = this.routeList.find(x => x.id == this.selectedRouteId)?.value  // NOSONAR

  }
  domicileListChange() {

    this.routeList = []
    const selectedDomiciles = this.domicileList.filter(x => x.isChecked).map(x => x.value)
    const tempRoutes = this.domicileRouteMasterList.filter(x => selectedDomiciles.includes((x.domicile)))
    this.routeList.push({
      id: 0, value: "--"
    })
    tempRoutes.forEach((obj, index) => {
      if (obj.route != null)  // NOSONAR
        {this.routeList.push({ id: index + 1, value: String(obj.route).trim() })}
    })
    this.routeList = [... new Map(this.routeList.map(x => [x['value'], x])).values()];
    this.routeList.sort((a, b) => (a.value > b.value ? 1 : -1))
    this.selectedRouteId = null
    this.selectedRouteValue = null;
    if (this.routeList.length > 0) {
      this.selectedRouteId = this.routeList[0].id
      this.routeChange()
    }
  }
  public saveClick() {
    this.errormsg = ""
    if (this.isValueOk(this.selectedPeriodId)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.selectedEWConfigurationId)) {
      this.showError(this.constants.formInputError);
    } else {
      this.errormsg = ""
      const EWDescription = this.ewconfigurationList.find(x => x.id == this.selectedEWConfigurationId).value  // NOSONAR
      let RouteDescription = this.routeList.find(x => x.id == this.selectedRouteId)?.value  // NOSONAR
      if (this.selectedRouteId == 0) {  // NOSONAR
        RouteDescription = null
      }
      let finalSelectedDomiciles = this.domicileList.filter(x => x.isChecked).map(x => x.value).toString();
      if (finalSelectedDomiciles == "") {  // NOSONAR
        finalSelectedDomiciles = null;
      }

      this.dateChange();
      if (this.eventType == "ADD") {  // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.ewconfigureService.addEWConfiguration(this.selectedPeriodId, EWDescription, RouteDescription, this.modifiedroutedate, finalSelectedDomiciles, null).subscribe(
          response => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") {  // NOSONAR
              this.dialogRef.close({
                event: "SaveEvent",
                eventType: this.eventType,
              });
            } else {
              this.showError(response)
            }
          }, error => {
            console.info(error)
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.showError(this.constants.APIErrorMessage)
          }
        )

      } else if (this.eventType == "EDIT") {  // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.ewconfigureService.updateEWConfiguration(RouteDescription, this.modifiedroutedate, finalSelectedDomiciles, this.ewID, EWDescription).subscribe(
          response => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") {  // NOSONAR
              this.dialogRef.close({
                event: "SaveEvent",
                eventType: this.eventType,
              });
            } else {
              this.showError(this.constants.APIErrorMessage)
            }
          }, error => {
            console.info(error)
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.showError(this.constants.APIErrorMessage)
          }
        )
      }

    }
  }

  showError(message) {
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = "";
    }, this.constants.notificationMessageTime);
  }
  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
{
      return true;
}
    return false;
  }


}
